<template>
  <div
    class="container selective-process-filter-dialog pt-5 pb-5"
  >
    <div class="row">
      <div class="col-12">
        <h3>
          Filtrar por processo seletivo
        </h3>
      </div>
    </div>
    <div
      class="row"
    >
      <div class="col-12">
        <select
          class="form-control"
          v-model="selected_selective_processes"
          @change="filterCandidates"
        >
          <option
            v-for="(selective_process, index) in selective_processes"
            :key="index"
            :value="selective_process.id"
          >
            {{ selective_process.name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    selective_processes: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      selected_selective_processes: [],
    }
  },

  methods: {
    filterCandidates() {
      eventBus.$emit('closeSelectiveProcessFilterDialog', this.selected_selective_processes);
    }
  }
}
</script>

<style scoped>
.selective-process-filter-dialog {
  max-height: 80vh;
  overflow-y: auto;
}

.btn-save-filter {
  background-color: #6f42c1;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  float: right;
}

</style>